import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const GET_SERVICE_TYPES_INVOCE = "GET_SERVICE_TYPES_INVOCE";
export const GET_SERVICE_TYPES_INVOCE_LOADING =
"GET_SERVICE_TYPES_INVOCE_LOADING";
export const GET_SERVICE_TYPES_INVOCE_LOADING_FAILED =
"GET_SERVICE_TYPES_INVOCE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const getServiceTypesLoading = ms => ({
    type: GET_SERVICE_TYPES_INVOCE_LOADING,
    payload: ms
    });
    
    export const getServiceTypesLoadingFailed = ms => ({
    type: GET_SERVICE_TYPES_INVOCE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function getServiceTypes() {
    const request = axios.get(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/serviceType/getServiceType`,
    {
      headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
    });
    return dispatch => {

    dispatch(getServiceTypesLoading());
 
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
     console.log(response,"response getServiceTypes")
    dispatch({
    type: GET_SERVICE_TYPES_INVOCE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        getServiceTypesLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(getServiceTypesLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(getServiceTypesLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(getServiceTypesLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


